module.exports = __webpack_public_path__ + "static/img/23.707ee6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/23.jpg
// module id = t0Cn
// module chunks = 1